// Minnesotaänger Mini App — avatar.
// Restored to telegram-tt's Avatar DOM contract so the baseline
// Avatar.scss applies: `.Avatar.size-large.peer-color-N.no-photo`
// with `--_size` style and `.inner > .letters` (first letters).
// telegram-tt derives the peer color from ApiPeer.color, falling
// back to `getPeerIdDividend(peer.id) % 7`; v1 has no peer data,
// so the color comes from a stable hash of the chat id — same
// `peer-color-N` classes, same colors. Removed: photos, stories,
// badges, premium gradient — v1 has no such data.

import { memo } from '@teact';

import buildClassName from '../../util/buildClassName';
import { getFirstLetters } from '../../util/textFormat';

import './Avatar.scss';

type OwnProps = {
  name: string;
  chatId: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

const AVATAR_SIZES = {
  small: 2.125 * 16, // 34px
  medium: 2.75 * 16, // 44px
  large: 3.375 * 16, // 54px
} as const;

// telegram-tt: `getPeerIdDividend(peer.id) % 7` when the peer has no color.
function hashChatId(chatId: string): number {
  let hash = 0;
  for (let i = 0; i < chatId.length; i++) {
    hash = ((hash << 5) - hash + chatId.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function Avatar({ name, chatId, size = 'large', className }: OwnProps) {
  const fullClassName = buildClassName(
    'Avatar',
    `size-${size}`,
    `peer-color-${hashChatId(chatId) % 7}`,
    'no-photo',
    className,
  );

  return (
    <div className={fullClassName} style={`--_size: ${AVATAR_SIZES[size]}px`}>
      <div className="inner">
        <span className="letters">{getFirstLetters(name)}</span>
      </div>
    </div>
  );
}

export default memo(Avatar);
